import { useTranslation } from "react-i18next";

import { NothingConfigured, Typography } from "@digital-services/ui";

import BigKeyIcon from "@icons/key_96.svg?react";

import { CreateApiSecretButton } from "./CreateApiSecretButton";

interface Props {
  message1?: string;
  message2?: string;
}

export function NoApiSecretsConfigured(props: Readonly<Props>) {
  const { t: tApiUserTab } = useTranslation(undefined, {
    keyPrefix: "api-users"
  });

  const msg1 = props.message1 || "There are no API secrets yet";
  const msg2 = props.message2 || tApiUserTab("messages.users-no-data-2");

  return (
    <NothingConfigured
      title={msg1}
      icon={<BigKeyIcon />}
      actionButton={
        <div className="mt-8">{false ? <CreateApiSecretButton /> : null}</div>
      }
    >
      <Typography className="max-w-[260px] text-center" variant="description">
        {msg2}
      </Typography>
    </NothingConfigured>
  );
}
